// extracted by css-extract-rspack-plugin
export default {"favicon":"WebsiteFavicon_favicon__n5pcG"};